{
  "el": {
    "document": {
      "actions": {
        "clear_selection": "Εκκαθάριση επιλογής",
        "delete": "Διαγραφή",
        "deleteMultipleDocuments": "Διαγραφή",
        "delete_cancel": "Ακύρωση",
        "delete_documents": "Διαγραφή εγγράφου | Διαγραφή εγγράφων",
        "delete_documents_upload": "Αφαίρεση {count} εγγράφου | Αφαίρεση {count} εγγράφων",
        "download": "Λήψη",
        "edit": "Επεξεργασία",
        "edit_category": "Επεξεργασία κατηγορίας",
        "groupByCategory": "Εναλλαγή ομαδοποίησης ανά κατηγορία",
        "hideDetails": "Απόκρυψη λεπτομερειών",
        "hide_for_project_partners": "Απόκρυψη από τους συνεργάτες έργου",
        "new": "Έγγραφα",
        "new_customer": "Προσθήκη εγγράφων",
        "reset_filters": "Επαναφορά φίλτρων",
        "select_all": "Επιλογή και των {total} εγγράφων",
        "share": "Κοινοποίηση",
        "shareCustomer": "Κοινοποίηση στον πελάτη",
        "shareCustomerPartners": "Κοινοποίηση στον πελάτη και στους συνεργάτες έργου",
        "share_documents": "Κοινοποίηση εγγράφου | Κοινοποίηση εγγράφων",
        "share_with": "Κοινοποίηση σε...",
        "share_with_project_partners": "Κοινοποίηση στους συνεργάτες έργου",
        "showDetails": "Εμφάνιση λεπτομερειών",
        "submit": "Υποβολή",
        "tickBoxesDeletion": "Τσέκαρε τα πλαίσια των αρχείων που θέλεις να διαγραφούν.",
        "unshare": "Κατάργηση κοινοποίησης",
        "unshare_documents": "Κατάργηση κοινοποίησης εγγράφου | Κατάργηση κοινοποίησης εγγράφων"
      },
      "attachable_types": {
        "building": "Κτίριο",
        "decisions": "Αποφάσεις",
        "installment": "Δόση",
        "issue": "Παρατήρηση",
        "lot": "Οικόπεδο",
        "phase": "Φάση",
        "project": "Έργο",
        "tickets": "Συνομιλίες",
        "unit": "Ακίνητο"
      },
      "attributes": {
        "category": "Κατηγορία",
        "file_ext": "Τύπος αρχείου",
        "file_size": "Μέγεθος αρχείου",
        "name": "Όνομα",
        "size": "Μέγεθος",
        "type": "Τύπος",
        "uploaded_at": "Ανέβηκε στις",
        "uploaded_by": "Ανέβηκε από"
      },
      "category": {
        "admin": "Διοικητικά",
        "aftercare": "Παρατηρήσεις",
        "as_built": "Ταυτότητα κτιρίου",
        "brochure": "Φυλλάδιο",
        "conversation": "Συνομιλία",
        "decision": "Απόφαση",
        "image": "Εικόνα",
        "invoice": "Τιμολόγιο",
        "legal": "Νομικά",
        "manual": "Εγχειρίδιο",
        "other": "Άλλο",
        "plan": "Σχέδιο",
        "quote": "Προσφορά",
        "ticket": "Συνομιλία"
      },
      "labels": {
        "actions": "Ενέργειες",
        "allDocuments": "Όλα τα έγγραφα",
        "allUnits": "Όλα τα ακίνητα",
        "backToCategories": "Κατηγορίες",
        "building": "κτίριο",
        "categories": "Κατηγορίες",
        "category": "Κατηγορία",
        "changeCategory": "Αλλαγή κατηγορίας σε:",
        "changeFilterOrStartUploading": "Άλλαξε φίλτρο ή ανέβασε νέο έγγραφο",
        "created": "Δημιουργήθηκε",
        "customer": "Πελάτης",
        "decision": "απόφαση",
        "decisionsAndProposals": "Αποφάσεις και προτάσεις",
        "delete_documents": "Θέλεις σίγουρα να διαγράψεις αυτό το έγγραφο; Η ενέργεια δεν μπορεί να αναιρεθεί. | Θέλεις σίγουρα να διαγράψεις αυτά τα έγγραφα; Η ενέργεια δεν μπορεί να αναιρεθεί.",
        "disclaimerDocumentsCustomer": "Βρες ή ανέβασε έγγραφα που σχετίζονται με την απόφαση {decision_name}",
        "documents": "Έγγραφα",
        "documents_all": "Όλα τα έγγραφα",
        "documents_all_projects": "Έγγραφα όλων των έργων",
        "documents_plan": "Έγγραφα σχεδίων",
        "documents_plan_explainer": "Τα έγγραφα που προστίθενται στον φάκελο εγγράφων {unit_name} με την κατηγορία «Σχέδιο» προστίθενται αυτόματα σε αυτή την απόφαση και είναι προσβάσιμα από όλους τους συνεργάτες. ",
        "editDocument": "Επεξεργασία εγγράφου",
        "editDocumentName": "Επεξεργασία ονόματος εγγράφου",
        "editDocumentNameSubtitle": "Δώσε ένα νέο όνομα για το έγγραφο.",
        "fileTooLargeForPreview": "Το αρχείο είναι πολύ μεγάλο για προεπισκόπηση. Δοκίμασε να το κατεβάσεις.",
        "files": "Αρχεία {level_name}",
        "files_count": "Κανένα αρχείο | 1 αρχείο | {count} αρχεία",
        "filter": "Φίλτρο",
        "folders": "Φάκελοι",
        "goToUnitDocumentsFolder": "Μετάβαση στον φάκελο εγγράφων {unit_name}",
        "goToUnitsFolder": "Αυτή η σελίδα περιέχει μόνο έγγραφα αποφάσεων. Πήγαινε στον φάκελο του ακινήτου για να δεις τα υπόλοιπα έγγραφα.",
        "include_original_documents": "Εμφάνιση των εγγράφων προς υπογραφή",
        "includesProposalAndDocuments": "Περιλαμβάνει έγγραφα πρότασης και έγγραφα απόφασης",
        "info": "Τα έγγραφα που σχετίζονται με το σπίτι σου θα είναι σύντομα διαθέσιμα εδώ.",
        "lockedDocumentApprovedProposal": "Αυτό το έγγραφο ανήκει σε εγκεκριμένη πρόταση και δεν μπορεί να διαγραφεί",
        "lockedDocumentDelete": "Αυτό το έγγραφο δεν μπορεί να διαγραφεί",
        "lockedDocumentOtherLevel": "Αυτό το έγγραφο ανήκει στο επίπεδο «{level}» και μπορεί να διαγραφεί μόνο από τα έγγραφα του επιπέδου «{level}»",
        "lockedDocumentShareLevel": "Αυτό το έγγραφο ανήκει στο επίπεδο «{level}» και δεν μπορεί να κοινοποιηθεί στους συνεργάτες έργου",
        "locked_parent_level": "Αυτό το έγγραφο το διαχειρίζεται ανώτερο επίπεδο και μπορεί να επεξεργαστεί ή να διαγραφεί μόνο εκεί",
        "locked_template": "Αυτό το έγγραφο δημιουργήθηκε από πρότυπο και δεν μπορεί να επεξεργαστεί ή να διαγραφεί",
        "lot": "οικόπεδο",
        "more_info": "Περισσότερες πληροφορίες",
        "name_asc": "Όνομα Α → Ω",
        "name_desc": "Όνομα Ω → Α",
        "name_lower_asc": "Όνομα Α → Ω",
        "name_lower_desc": "Όνομα Ω → Α",
        "new": "Νέο",
        "next": "Επόμενο",
        "noCustomer": "Δεν έχει ανατεθεί ακόμη πελάτης",
        "noPreviewPossible": "Δεν είναι δυνατή η προεπισκόπηση για αυτόν τον τύπο εγγράφου. Δοκίμασε να το κατεβάσεις πρώτα.",
        "noResults": "Κανένα αποτέλεσμα",
        "no_plan_documents": "Δεν έχουν προστεθεί έγγραφα σχεδίων στον φάκελο του ακινήτου",
        "onlyUnitDocumentsSharedWithProjectPartners": "Μόνο τα έγγραφα ακινήτου μπορούν να κοινοποιηθούν στους συνεργάτες έργου",
        "original_documents": "Πρωτότυπα έγγραφα",
        "original_documents_info": "Εμφάνιση των πρωτότυπων ανυπόγραφων εκδόσεων των εγγράφων που έχουν υπογραφεί ή πρέπει να υπογραφούν.",
        "owner": "Ιδιοκτήτης",
        "page": "Σελίδα",
        "phase": "φάση",
        "previous": "Προηγούμενο",
        "project": "έργο",
        "project_partners": "Συνεργάτες έργου",
        "proposal": "πρόταση",
        "searchName": "Αναζήτηση με όνομα",
        "search_document": "Αναζήτηση εγγράφου",
        "selected": "{count} επιλεγμένο έγγραφο | {count} επιλεγμένα έγγραφα",
        "selected_count": "{selected} επιλεγμένο έγγραφο | {selected} επιλεγμένα έγγραφα",
        "shareWith": "Κοινοποίηση σε",
        "sharedWithClient": "Κοινοποιήθηκε σε {client_name}",
        "sharedWithProjectPartners": "Κοινοποιήθηκε στους συνεργάτες έργου",
        "shared_with": "Κοινοποιήθηκε σε",
        "shared_with_partners": "Κοινοποιήθηκε στους συνεργάτες",
        "sharingSettingsDecision": "Μέσα σε αυτή την απόφαση",
        "sharingSettingsProject": "Σε αυτό το έργο",
        "showDocumentsFor": "Εμφάνιση εγγράφων για",
        "showLevel": "Αυτό είναι έγγραφο επιπέδου «{level}»",
        "signature": "Υπογραφή",
        "signed": "Υπογεγραμμένο",
        "signedBy": "Υπογράφηκε από",
        "source": "Προέλευση",
        "subtitleSharingDocuments": "Το επιλεγμένο έγγραφο θα είναι διαθέσιμο στους συνεργάτες έργου | Τα επιλεγμένα έγγραφα θα είναι διαθέσιμα στους συνεργάτες έργου",
        "subtitleUnsharingDocuments": "Το επιλεγμένο έγγραφο δεν θα είναι διαθέσιμο στους συνεργάτες έργου | Τα επιλεγμένα έγγραφα δεν θα είναι διαθέσιμα στους συνεργάτες έργου",
        "ticket": "συνομιλία",
        "total_selected": "Επιλέχθηκαν και τα {total} έγγραφα",
        "unit": "ακίνητο",
        "unitFolder": "Μετάβαση στα έγγραφα του ακινήτου",
        "updated_at_asc": "Παλαιότερα πρώτα",
        "updated_at_desc": "Νεότερα πρώτα",
        "upload_failed": "Ένα ή περισσότερα αρχεία δεν ανέβηκαν. Αφαίρεσέ τα ή δοκίμασε να τα ανεβάσεις ξανά.",
        "uploadedBy": "Ανέβηκε από",
        "visibleFor": "Κοινοποιήθηκε σε",
        "warningNotShared": "Ωχ, δεν έχει επιλεγεί κανείς. Θέλεις σίγουρα να συνεχίσεις; Κάνε ξανά κλικ για επιβεβαίωση."
      },
      "placeholders": {
        "customers": {
          "none": {
            "subtitle": "Θα λάβεις ειδοποίηση με email όταν είναι διαθέσιμο ένα νέο έγγραφο. Δες και κατέβασε τα έγγραφα εδώ.",
            "title": "Εδώ θα βρεις όλα τα έγγραφά σου"
          }
        },
        "employees": {
          "new": {
            "subtitle": "Το ανέβασμα εγγράφων ειδοποιεί αυτόματα με email όλους τους σχετικούς πελάτες.",
            "title": "Δεν υπάρχουν έγγραφα για {level_name}"
          }
        },
        "partners": {
          "navigate": {
            "subtitle": "Πλοηγήσου στη δομή του έργου για να δεις τα έγγραφα ενός ακινήτου",
            "title": "Πήγαινε σε ένα ακίνητο για να δεις έγγραφα"
          },
          "new": {
            "subtitle": "Το ανέβασμα εγγράφων ειδοποιεί αυτόματα με email όλους τους σχετικούς πελάτες.",
            "title": "Δεν υπάρχουν έγγραφα για αυτή την απόφαση"
          },
          "none": {
            "subtitle": "Εδώ θα βρεις έγγραφα για {unit}",
            "title": "Δεν υπάρχουν ακόμη έγγραφα"
          }
        }
      },
      "toasts": {
        "bulk_delete": "Το έγγραφο διαγράφηκε | Τα έγγραφα διαγράφηκαν",
        "bulk_upload": "Το έγγραφο ανέβηκε | Τα έγγραφα ανέβηκαν",
        "update": "Ενημερώθηκε {count} έγγραφο | Ενημερώθηκαν {count} έγγραφα",
        "upload_success": "Ανέβηκε {count} έγγραφο | Ανέβηκαν {count} έγγραφα"
      },
      "upload": {
        "activeUpload": "Ανέβασμα {count} αρχείου... | Ανέβασμα {count} αρχείων...",
        "clear": "Εκκαθάριση",
        "complete": "Το ανέβασμα ολοκληρώθηκε",
        "navigationWarning": {
          "continue": "Αποχώρηση παρ' όλα αυτά",
          "header": "Ανέβασμα σε εξέλιξη",
          "message": "Αυτή τη στιγμή ανεβαίνουν αρχεία. Αν φύγεις από αυτή τη σελίδα, το ανέβασμα θα ακυρωθεί και δεν θα δημιουργηθεί κανένα έγγραφο."
        },
        "uploadFailed": "Το ανέβασμα απέτυχε"
      },
      "validation": {
        "need_category": "Απαιτείται κατηγορία",
        "need_category_all": "Όλα τα έγγραφα πρέπει να έχουν κατηγορία",
        "selectDocument": "Επίλεξε τουλάχιστον 1 έγγραφο"
      }
    }
  }
}
